/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />

module Eseebase {
    export class CookiesService {
        public isOciMode: boolean;
        constructor() {
            this.isOciMode = false;
         }

        public createCookie(name: string, value: string, minutes: number) {
            var expires = "";
            var path = "/";
            if (this.isOciMode) {
                path = path + "oci";
                name = "oci_" + name;
                minutes = 0;
            }
            if (minutes) {
                var date = new Date();
                date.setMinutes(date.getMinutes() + minutes);
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + value + expires + "; path=" + path;
        }

        public readCookie(name: string) {
            if (this.isOciMode) {
                name = "oci_" + name;
            }
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

        public deleteCookie(name: string) {
            var expires = "";
            var path = "/";
            if (this.isOciMode) {
                path = path + "oci";
                name = "oci_" + name;
            }
            var minutes = -60;
            if (minutes) {
                var date = new Date();
                date.setMinutes(date.getMinutes() + minutes);
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=test" + expires + "; path=" + path;
        }
    }

    CookiesService.$inject = [];
    angular
        .module('eseebase')
        .service('CookiesService', CookiesService);
}